import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import FillResults from "./FillResults";
import Row from "react-bootstrap/Row";
import "../main.css";
import NumSubmits from "./NumSubmits";
import Spinner from "react-bootstrap/Spinner";

const TIRE_PLY_STMT = "Choose Tire Construction...";

function CalcForm({
  addTireSizeSubmit,
  getTireFill,
  numSubmits,
  numFills,
  notation,
  msrmtNames,
  initValues,
}) {
  const [fillData, setFillData] = useState(false);
  const firstLetterUpperNotation =
    notation.charAt(0).toUpperCase() + notation.slice(1);

  const dataSchema = msrmtNames.one
    ? Yup.object().shape({
        measurements: Yup.object({
          firstNum: Yup.number()
            .typeError("Please only enter digits")
            .moreThan(0, "Please enter a number greater than 0")
            .required("Required"),
          middleNum: Yup.number()
            .typeError("Please only enter digits")
            .moreThan(0, "Please enter a number greater than 0")
            .required("Required"),
          lastNum: Yup.number()
            .typeError("Please only enter digits")
            .moreThan(0, "Please enter a number greater than 0")
            .required("Required"),
        }),
        construction: Yup.string()
          .notOneOf([TIRE_PLY_STMT], "Please select an option")
          .required("Please select an option"),
      })
    : Yup.object().shape({
        measurements: Yup.object({
          firstNum: Yup.number()
            .typeError("Please only enter digits")
            .moreThan(0, "Please enter a number greater than 0")
            .required("Required"),
          lastNum: Yup.number()
            .typeError("Please only enter digits")
            .moreThan(0, "Please enter a number greater than 0")
            .required("Required"),
        }),
        construction: Yup.string()
          .notOneOf([TIRE_PLY_STMT], "Please select an option")
          .required("Please select an option"),
      });

  return (
    <div className="mb-4 mt-3 pb-0">
      <Formik
        enableReinitialize={true}
        initialValues={{
          measurements: {
            firstNum: "",
            middleNum: "",
            lastNum: "",
          },
          construction: TIRE_PLY_STMT,
        }}
        validationSchema={dataSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          let tireSize;
          if (notation === "metric") {
            tireSize = {
              measurements: {
                tireWidth: values.measurements.firstNum,
                aspectRatio: values.measurements.middleNum,
                rimDia: values.measurements.lastNum,
              },
              construction: values.construction,
              notation: "metric",
            };
          } else {
            tireSize = {
              measurements: {
                tireWidth: values.measurements.firstNum,
                rimDia: values.measurements.lastNum,
              },
              construction: values.construction,
              notation: "stdTwoNums",
            };
          }
          const reqData = await getTireFill(tireSize);
          const jsonData = await reqData.json();
          const data = jsonData.tireFillData;
          try {
            addTireSizeSubmit(tireSize, data.matchType)
              .then((value) => console.log("received", value))
              .catch((err) =>
                console.log("error uploading tire size submission", err)
              );
          } catch (err) {
            console.log("ERROR");
            console.log(err);
          }
          setFillData(data);
          resetForm();
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <div>
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group
                  as={Col}
                  controlId={`first${firstLetterUpperNotation}Number`}
                >
                  <Form.Control
                    placeholder="1st Number"
                    name={`measurements.firstNum`}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.measurements.firstNum}
                    isInvalid={
                      errors?.measurements?.firstNum &&
                      touched?.measurements?.firstNum
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.measurements?.firstNum}
                  </Form.Control.Feedback>
                </Form.Group>
                {/* {msrmtNames.one ? (
                  <div>
                    <h3 className="mx-1 mx-md-1">
                      /{" "}
                      <span
                        style={{ "font-weight": "normal", "font-size": 22 }}
                      >
                        or{" "}
                      </span>
                      X
                    </h3>
                  </div>
                ) : (
                  <div></div>
                )} */}
                {notation === "metric" ? (
                  <Form.Group
                    className="mx-0 px-0 mx-md-1"
                    as={Col}
                    controlId={`second${firstLetterUpperNotation}Number`}
                  >
                    <Form.Control
                      placeholder={"Middle Number"}
                      name={`measurements.middleNum`}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.measurements.middleNum}
                      isInvalid={
                        errors?.measurements?.middleNum &&
                        touched?.measurements?.middleNum
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.measurements?.middleNum}
                    </Form.Control.Feedback>
                  </Form.Group>
                ) : (
                  <div></div>
                )}
                <Form.Group
                  className="mx-0 mx-md-1"
                  as={Col}
                  controlId="formGridState"
                >
                  <Form.Control
                    as="select"
                    // defaultValue={"Choose..."}
                    name={`construction`}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.construction}
                    isInvalid={errors?.construction && touched?.construction}
                    custom
                  >
                    <option>{TIRE_PLY_STMT}</option>
                    <option value="DONT_KNOW">I don't know</option>
                    <option value="BIAS_PLY">- (Bias Ply)</option>
                    <option value="BIAS_PLY_X">X (Bias Ply As Well)</option>
                    <option value="RADIAL">R (Radial)</option>
                    <option value="BELTED_BIAS">B (Belted Bias Ply)</option>
                    <option value="DIAGONAL_BIAS">D (Diagonal Bias Ply)</option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors?.measurements?.construction}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  className="mx-0 px-0 mx-md-1"
                  as={Col}
                  controlId="thirdMetricNumber"
                >
                  <Form.Control
                    placeholder={"Last Number"}
                    name={`measurements.lastNum`}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.measurements.lastNum}
                    isInvalid={
                      errors?.measurements?.lastNum &&
                      touched?.measurements?.lastNum
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.measurements?.lastNum}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>

              {numSubmits && numFills ? (
                <div>
                  <NumSubmits
                    key={"submits"}
                    numSubmits={numSubmits}
                    numFills={numFills}
                  />
                  <Form.Row className="justify-content-center mt-4">
                    <Button
                      className="btn-rg-purple mb-0"
                      type="submit"
                      disabled={isSubmitting}
                      size="lg"
                    >
                      Calculate Gallons
                    </Button>
                  </Form.Row>
                </div>
              ) : (
                // <Form.Row className="justify-content-center mt-4">
                <Form.Row className="d-flex align-items-center justify-content-center">
                  <Button
                    className="btn-rg-purple"
                    type="submit"
                    disabled={true}
                    size="lg"
                  >
                    Loading Data...
                  </Button>
                  <Spinner
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                    className="mx-3 text-rg-purple"
                    style={{ color: "rgba(178, 178, 178, 1)" }}
                  />
                </Form.Row>
              )}
              {isSubmitting ? (
                <Row className="justify-content-center pt-5">
                  <Spinner
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                    className="mr-3 text-rg-purple"
                    style={{ color: "rgba(84, 147, 77, 1)" }}
                  />
                </Row>
              ) : (
                <div></div>
              )}
              {fillData && !isSubmitting ? (
                <FillResults fillData={fillData} />
              ) : (
                <div></div>
              )}
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default CalcForm;
